import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { api, GetFormat } from 'sharedKernel/api'
import { NoContent } from 'components/NoContent'
import { Loading } from 'components/loading'
import { showToast } from 'components/toast'
import {
  changeEventFiles,
  changeEventConfigSection,
  fullResetEvent,
  IEventFileStructure,
  IHubEventBasicFormFilesState,
  IHubEventBasicFormState,
  EventResponse,
  store
} from 'store'
import { HubCompanyNewEventPage } from '../new'

function formatDate(date: string): string {
  const newDate = date.replace('T00:00:00', '')
  return newDate
}

export const fixDatas = (_eventState: IHubEventBasicFormState): void => {
  _eventState.startDate = formatDate(_eventState.startDate)
  if (_eventState.endDate !== null) {
    _eventState.endDate = formatDate(_eventState.endDate)
  }
}

export const HubCompanyEventEditPage = (props): any => {
  const { eventId } = useParams()
  const [eventState, setEventState] = useState<any>()
  const [eventStateFile, setEventStateFile] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const labels = { noContent: 'Evento não encontrado', noFiles: 'Falha ao buscar arquivos' }

  const request: GetFormat = {
    url: `/v1/hub/company/event/${eventId}`
  }
  const filesRequest: GetFormat = {
    url: `/v1/hub/company/event/${eventId}/files`
  }

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        store.dispatch(fullResetEvent(eventState))

        const response1 = await api.get<EventResponse>(request.url)
        setEventState({ ...response1.data.data, id: eventId })

        const response2 = await api.get(filesRequest.url)
        setEventStateFile(response2.data)

        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [])

  if (eventId !== undefined) {
    if (isLoading) {
      return (
        <Loading />
      )
    }

    if (eventState === null || eventState === undefined) {
      return <NoContent text={labels.noContent} />
    }
    if (eventState.startDate !== null) {
      fixDatas(eventState)
    }
    store.dispatch(changeEventConfigSection(eventState))

    if (eventStateFile.rows != null) {
      const files: IEventFileStructure[] = eventStateFile.rows

      const filesEventState: IHubEventBasicFormFilesState = {
        eventFiles: files.filter((file) => file.type === 'supportFiles'),
        deletedEventFiles: [],
        homePageSlider: files.find((file) => file.type === 'homePageSlider'),
        presentationVideo: files.find((file) => file.type === 'presentationVideo'),
        coverImage: files.find((file) => file.type === 'coverImage')
      }
      store.dispatch(changeEventFiles(filesEventState))
    } else {
      showToast('error', labels.noFiles)
    }
  }

  return <HubCompanyNewEventPage />
}
